import React, { useState } from 'react';
import { AllStoresSectionWrapper, PeoplesWrap, StoresWrap, StoreWrap } from './AllStoresSection.style';
import StoreWhite from '../../../assets/store-white.png';
import Profile1 from '../../../assets/profie1.png';
import Profile2 from '../../../assets/profile2.png';
import Profile3 from '../../../assets/profile3.png';
import Button from '../../molecules/Button';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { HiPencil, HiTrash } from 'react-icons/hi2';
import CenterModal from '../../molecules/Modal/CenterModal';
import SuccessModal from '../SuccessModal';
import { FaArrowLeft } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import AddBusinessModal from '../AddBusinessModal';
import AddStoreModal from '../AddStoreModal';
import Pagination from '../../molecules/Pagination';
import { NoRecordFound } from '../../molecules/Table/Table.styles';
import { BiSolidDetail } from 'react-icons/bi';
import Captcha from '../CaptchaComponent';
import storeService from '../../../services/storeService';
import Toast from '../../molecules/Toast';
import MenuButton, { MenuItem } from '../Menu';
import ModalContainer from '../../molecules/ModalContainer';
import businessService from '../../../services/businessService';
import Loaders from '../Loaders';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import StoreDetails from '../StoreDetails';

const AllStoresSection = ({
  CreateStoreModal,
  data,
  refetch,
  currentPage = 1,
  pageSize = 10,
  onChangeFilters,
  stores_loading,
}) => {
  const { hasPermission } = useContextHook(AuthContext, ['hasPermission']);

  const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
  const [deleteStoreSuccessModal, setDeleteStoreSuccessModal] = useState(false);

  const [filterState, setFilterState] = useState('');

  const navigate = useNavigate();
  const handelDeactivate = async (id, reason, onClose) => {
    try {
      const { message } = await storeService.deleteStore(id, reason);
      Toast({
        type: 'success',
        message,
      });
      refetch();
      onClose();
      setDeleteStoreSuccessModal(true);
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
    }
  };
  const handelDeactivateBusiness = async (id, reason, onClose) => {
    try {
      const { message } = await businessService.deleteBusiness(id, reason);
      Toast({
        type: 'success',
        message,
      });
      refetch();
      onClose();
      setDeleteSuccessModal(true);
      navigate('/business');
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
    }
  };
  return (
    <>
      {/* ------------------- Modal Start ------------------- */}

      {/* ------------------- Delete Business Modal Start ------------------- */}

      <CenterModal open={deleteSuccessModal} setOpen={setDeleteSuccessModal} iscloseAble={false} width="580">
        <SuccessModal
          heading="Business Deleted Successfully!"
          btnText="Go Back"
          btnClick={() => setDeleteSuccessModal(false)}
        />
      </CenterModal>

      {/* ------------------- Delete Business Modal End ------------------- */}

      {/* ------------------- Delete Store Modal Start ------------------- */}

      <CenterModal open={deleteStoreSuccessModal} setOpen={setDeleteStoreSuccessModal} iscloseAble={false} width="580">
        <SuccessModal
          heading="Store Deleted Successfully!"
          btnText="Go Back"
          btnClick={() => setDeleteStoreSuccessModal(false)}
        />
      </CenterModal>

      {/* ------------------- Delete Store Modal End ------------------- */}

      {/* ------------------- Modal End ------------------- */}
      {stores_loading ? (
        <Loaders viewLoader />
      ) : (
        <AllStoresSectionWrapper $data={data?.stores.length > 0} $hasPagination={data?.totalItems > 1}>
          <div className="content-wrap business">
            <StoreWrap>
              <div className="arrow" onClick={() => navigate(-1)}>
                <FaArrowLeft />
              </div>
              <div className="icon">
                <img src={StoreWhite} alt="store" />
              </div>
              <div>
                <h2 className="title">{data?.businessData?.businessData?.title}</h2>
                <span className="desc">
                  {data?.totalItems} {data?.stores?.length > 1 ? 'Stores' : 'Store'}
                </span>
              </div>
            </StoreWrap>
            <div className="add-btn">
              {hasPermission('store.add-store') && (
                <Button width="117px" onClick={CreateStoreModal}>
                  + Add Store
                </Button>
              )}
            </div>
            <div className="dots">
              <MenuButton icon={<BsThreeDotsVertical size={20} color="#9D9D9D" />}>
                {hasPermission('business.edit-business') && (
                  <ModalContainer
                    width="666"
                    title="Edit Business"
                    btnComponent={({ onClick }) => (
                      <MenuItem onClick={onClick}>
                        <HiPencil /> Edit Business
                      </MenuItem>
                    )}
                    content={({ onClose }) => (
                      <AddBusinessModal handleSubmit={onClose} businessData={data?.businessData?.businessData} />
                    )}
                  />
                )}
                {hasPermission('business.delete-business') && (
                  <ModalContainer
                    width="777"
                    title={'Are you sure you want to deactivate Bussiness'}
                    btnComponent={({ onClick }) => (
                      <MenuItem onClick={onClick}>
                        <HiTrash /> Deactivate Business
                      </MenuItem>
                    )}
                    content={({ onClose }) => (
                      <Captcha
                        type="Bussiness"
                        title={data?.businessData?.businessData?.title}
                        store
                        onDelete={({ reason }) => {
                          handelDeactivateBusiness(data?.businessData?.businessData?._id, reason, onClose);
                        }}
                      />
                    )}
                  />
                )}
              </MenuButton>
            </div>
          </div>
          {data.stores.length ? (
            data?.stores?.map((_, index) => (
              <div key={index} className="content-wrap stores">
                <StoresWrap $adjust style={{ opacity: _?.status === 'Active' ? 1 : 0.5 }}>
                  <div className="store-title">
                    <h2 className="title">{_?.title}</h2>
                    <span className="desc">{_?.address?.value}</span>
                  </div>
                </StoresWrap>
                <PeoplesWrap style={{ opacity: _?.status === 'Active' ? 1 : 0.5 }}>
                  <div className="profile-wrap">
                    <figure className="profile-pic">
                      <img src={Profile1} alt="profilePic" />
                    </figure>
                    <figure className="profile-pic">
                      <img src={Profile2} alt="profilePic" />
                    </figure>
                    <figure className="profile-pic">
                      <img src={Profile3} alt="profilePic" />
                    </figure>
                  </div>
                  <span
                    className="success"
                    onClick={() => {
                      navigate(`/business/business-store/users/${_?._id}`);
                    }}>
                    See Users
                  </span>
                </PeoplesWrap>
                <div className="btns-wrap" style={{ opacity: _?.status === 'Active' ? 1 : 0.5 }}>
                  <Button
                    width="150px"
                    variant="light-primary"
                    disabled={_?.status !== 'Active'}
                    onClick={() => {
                      if (_?.status === 'Active') {
                        navigate(`/business/business-store/devices/${_?._id}`);
                      }
                    }}>
                    View Devices
                  </Button>
                </div>

                <div className="dots">
                  <div className="action-btn">
                    <MenuButton icon={<BsThreeDotsVertical size={20} color="#9D9D9D" />}>
                      {_?.status === 'Active' && (
                        <>
                          {hasPermission('store.edit-store') && (
                            <ModalContainer
                              width="666"
                              title={`Edit ${_?.title}`}
                              btnComponent={({ onClick }) => (
                                <MenuItem onClick={onClick}>
                                  <HiPencil /> Edit Store
                                </MenuItem>
                              )}
                              content={({ onClose }) => (
                                <AddStoreModal
                                  onSubmit={onClose}
                                  data={data?.businessData?.businessData}
                                  isEdit={_}
                                  refetch={refetch}
                                />
                              )}
                            />
                          )}
                          {hasPermission('store.delete-store') && (
                            <ModalContainer
                              title={'Are you sure you want to deactivate Store'}
                              width="800"
                              btnComponent={({ onClick }) => (
                                <MenuItem onClick={() => onClick()}>
                                  <HiTrash /> Deactivate Store
                                </MenuItem>
                              )}
                              content={({ onClose }) => (
                                <Captcha
                                  type="store"
                                  title={_?.title}
                                  store
                                  onDelete={({ reason }) => {
                                    handelDeactivate(_?._id, reason, onClose);
                                  }}
                                />
                              )}
                            />
                          )}
                        </>
                      )}
                      {hasPermission('store.get-store-details') && (
                        <ModalContainer
                          title='Store Details'
                          width="800"
                          btnComponent={({ onClick }) => (
                            <MenuItem onClick={onClick}>
                              <BiSolidDetail /> Store Details
                            </MenuItem>
                          )}
                          content={({ onClose }) => <StoreDetails storeId={_?._id}/>}
                        />
                      )}
                    </MenuButton>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <NoRecordFound>No Record Found</NoRecordFound>
          )}

          <div className="pagination">
            {data?.totalItems > 1 ? (
              <Pagination
                currentPage={currentPage}
                totalCount={data?.totalItems}
                pageSize={pageSize}
                onPageChange={_ => onChangeFilters({ filter: filterState.filter, page: _ })}
              />
            ) : (
              ''
            )}
          </div>
        </AllStoresSectionWrapper>
      )}
    </>
  );
};

export default AllStoresSection;
